(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './boislocal-platform-platform-infra-commons-commons-domain.js', './boislocal-platform-platform-s2-realization-realization-domain.js', './boislocal-platform-platform-s2-ouvrage-ouvrage-domain.js', './fixers-s2-s2-automate-s2-automate-dsl.js', './fixers-f2-f2-dsl-f2-dsl-cqrs.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./boislocal-platform-platform-infra-commons-commons-domain.js'), require('./boislocal-platform-platform-s2-realization-realization-domain.js'), require('./boislocal-platform-platform-s2-ouvrage-ouvrage-domain.js'), require('./fixers-s2-s2-automate-s2-automate-dsl.js'), require('./fixers-f2-f2-dsl-f2-dsl-cqrs.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-f2-ouvrage-query-ouvrage-query-domain'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'boislocal-platform-platform-f2-ouvrage-query-ouvrage-query-domain'.");
    }
    if (typeof this['boislocal-platform-platform-infra-commons-commons-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-f2-ouvrage-query-ouvrage-query-domain'. Its dependency 'boislocal-platform-platform-infra-commons-commons-domain' was not found. Please, check whether 'boislocal-platform-platform-infra-commons-commons-domain' is loaded prior to 'boislocal-platform-platform-f2-ouvrage-query-ouvrage-query-domain'.");
    }
    if (typeof this['boislocal-platform-platform-s2-realization-realization-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-f2-ouvrage-query-ouvrage-query-domain'. Its dependency 'boislocal-platform-platform-s2-realization-realization-domain' was not found. Please, check whether 'boislocal-platform-platform-s2-realization-realization-domain' is loaded prior to 'boislocal-platform-platform-f2-ouvrage-query-ouvrage-query-domain'.");
    }
    if (typeof this['boislocal-platform-platform-s2-ouvrage-ouvrage-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-f2-ouvrage-query-ouvrage-query-domain'. Its dependency 'boislocal-platform-platform-s2-ouvrage-ouvrage-domain' was not found. Please, check whether 'boislocal-platform-platform-s2-ouvrage-ouvrage-domain' is loaded prior to 'boislocal-platform-platform-f2-ouvrage-query-ouvrage-query-domain'.");
    }
    if (typeof this['fixers-s2-s2-automate-s2-automate-dsl'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-f2-ouvrage-query-ouvrage-query-domain'. Its dependency 'fixers-s2-s2-automate-s2-automate-dsl' was not found. Please, check whether 'fixers-s2-s2-automate-s2-automate-dsl' is loaded prior to 'boislocal-platform-platform-f2-ouvrage-query-ouvrage-query-domain'.");
    }
    if (typeof this['fixers-f2-f2-dsl-f2-dsl-cqrs'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-f2-ouvrage-query-ouvrage-query-domain'. Its dependency 'fixers-f2-f2-dsl-f2-dsl-cqrs' was not found. Please, check whether 'fixers-f2-f2-dsl-f2-dsl-cqrs' is loaded prior to 'boislocal-platform-platform-f2-ouvrage-query-ouvrage-query-domain'.");
    }
    root['boislocal-platform-platform-f2-ouvrage-query-ouvrage-query-domain'] = factory(typeof this['boislocal-platform-platform-f2-ouvrage-query-ouvrage-query-domain'] === 'undefined' ? {} : this['boislocal-platform-platform-f2-ouvrage-query-ouvrage-query-domain'], this['kotlin-kotlin-stdlib'], this['boislocal-platform-platform-infra-commons-commons-domain'], this['boislocal-platform-platform-s2-realization-realization-domain'], this['boislocal-platform-platform-s2-ouvrage-ouvrage-domain'], this['fixers-s2-s2-automate-s2-automate-dsl'], this['fixers-f2-f2-dsl-f2-dsl-cqrs']);
  }
}(this, function (_, kotlin_kotlin, kotlin_org_boislocal_commons_domain, kotlin_org_boislocal_realization_domain, kotlin_org_boislocal_ouvrage_domain, kotlin_io_komune_s2_s2_automate_dsl, kotlin_io_komune_f2_f2_dsl_cqrs) {
  'use strict';
  //region block: imports
  var protoOf = kotlin_kotlin.$_$.fa;
  var interfaceMeta = kotlin_kotlin.$_$.k9;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  var Roles_instance = kotlin_org_boislocal_commons_domain.$_$.b;
  var hasRole = kotlin_org_boislocal_commons_domain.$_$.m;
  var S2_getInstance = kotlin_org_boislocal_realization_domain.$_$.a;
  var OuvrageUpdateCommand = kotlin_org_boislocal_ouvrage_domain.$_$.e;
  var getKClass = kotlin_kotlin.$_$.f;
  var ensureNotNull = kotlin_kotlin.$_$.be;
  var isAvailableTransition = kotlin_io_komune_s2_s2_automate_dsl.$_$.d;
  var OuvrageDeleteCommand = kotlin_org_boislocal_ouvrage_domain.$_$.b;
  var OuvrageFinishCommand = kotlin_org_boislocal_ouvrage_domain.$_$.c;
  var OuvrageUnlockCommand = kotlin_org_boislocal_ouvrage_domain.$_$.d;
  var objectMeta = kotlin_kotlin.$_$.ea;
  var defineProp = kotlin_kotlin.$_$.b9;
  var Query = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.e;
  var VOID = kotlin_kotlin.$_$.g;
  var PageQueryDTO = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.a;
  var PageQueryResultDTO = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.b;
  //endregion
  //region block: pre-declaration
  setMetadataFor(OuvrageDTO, 'OuvrageDTO', interfaceMeta);
  setMetadataFor(OuvragePolicies, 'OuvragePolicies', objectMeta);
  setMetadataFor(OuvrageGetQueryDTO, 'OuvrageGetQueryDTO', interfaceMeta, VOID, [Query]);
  setMetadataFor(OuvrageGetResponseDTO, 'OuvrageGetResponseDTO', interfaceMeta);
  setMetadataFor(OuvragePageQueryDTO, 'OuvragePageQueryDTO', interfaceMeta, VOID, [PageQueryDTO]);
  setMetadataFor(OuvragePageResponseDTO, 'OuvragePageResponseDTO', interfaceMeta, VOID, [PageQueryResultDTO]);
  //endregion
  function OuvrageDTO() {
  }
  function OuvragePolicies() {
  }
  protoOf(OuvragePolicies).canPage = function (authedUser) {
    return true;
  };
  protoOf(OuvragePolicies).canGet = function (authedUser) {
    return true;
  };
  protoOf(OuvragePolicies).canRefs = function (authedUser) {
    return true;
  };
  protoOf(OuvragePolicies).canCreate = function (authedUser) {
    return hasRole(authedUser, 'Marque');
  };
  protoOf(OuvragePolicies).canUpdate = function (authedUser, target) {
    // Inline function 'org.boislocal.platform.s2.commons.domain.model.canExecuteTransitionAnd' call
    var this_0 = S2_getInstance().s30_1;
    var tmp;
    if (isAvailableTransition(this_0, target, ensureNotNull(getKClass(OuvrageUpdateCommand).z5()))) {
      // Inline function 'org.boislocal.platform.f2.realization.query.domain.policy.OuvragePolicies.canUpdate.<anonymous>' call
      tmp = hasRole(authedUser, 'Marque');
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(OuvragePolicies).canDelete = function (authedUser, target) {
    // Inline function 'org.boislocal.platform.s2.commons.domain.model.canExecuteTransitionAnd' call
    var this_0 = S2_getInstance().s30_1;
    var tmp;
    if (isAvailableTransition(this_0, target, ensureNotNull(getKClass(OuvrageDeleteCommand).z5()))) {
      // Inline function 'org.boislocal.platform.f2.realization.query.domain.policy.OuvragePolicies.canDelete.<anonymous>' call
      tmp = hasRole(authedUser, 'Marque');
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(OuvragePolicies).canFinish = function (authedUser, target) {
    // Inline function 'org.boislocal.platform.s2.commons.domain.model.canExecuteTransitionAnd' call
    var this_0 = S2_getInstance().s30_1;
    var tmp;
    if (isAvailableTransition(this_0, target, ensureNotNull(getKClass(OuvrageFinishCommand).z5()))) {
      // Inline function 'org.boislocal.platform.f2.realization.query.domain.policy.OuvragePolicies.canFinish.<anonymous>' call
      tmp = hasRole(authedUser, 'Marque');
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(OuvragePolicies).canUnlock = function (authedUser, target) {
    // Inline function 'org.boislocal.platform.s2.commons.domain.model.canExecuteTransitionAnd' call
    var this_0 = S2_getInstance().s30_1;
    var tmp;
    if (isAvailableTransition(this_0, target, ensureNotNull(getKClass(OuvrageUnlockCommand).z5()))) {
      // Inline function 'org.boislocal.platform.f2.realization.query.domain.policy.OuvragePolicies.canUnlock.<anonymous>' call
      tmp = hasRole(authedUser, 'Marque');
    } else {
      tmp = false;
    }
    return tmp;
  };
  var OuvragePolicies_instance;
  function OuvragePolicies_getInstance() {
    return OuvragePolicies_instance;
  }
  function OuvrageGetQueryDTO() {
  }
  function OuvrageGetResponseDTO() {
  }
  function OuvragePageQueryDTO() {
  }
  function OuvragePageResponseDTO() {
  }
  //region block: init
  OuvragePolicies_instance = new OuvragePolicies();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$f2 = $org$boislocal$platform.f2 || ($org$boislocal$platform.f2 = {});
    var $org$boislocal$platform$f2$ouvrage = $org$boislocal$platform$f2.ouvrage || ($org$boislocal$platform$f2.ouvrage = {});
    var $org$boislocal$platform$f2$ouvrage$query = $org$boislocal$platform$f2$ouvrage.query || ($org$boislocal$platform$f2$ouvrage.query = {});
    var $org$boislocal$platform$f2$ouvrage$query$domain = $org$boislocal$platform$f2$ouvrage$query.domain || ($org$boislocal$platform$f2$ouvrage$query.domain = {});
    var $org$boislocal$platform$f2$ouvrage$query$domain$model = $org$boislocal$platform$f2$ouvrage$query$domain.model || ($org$boislocal$platform$f2$ouvrage$query$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$f2 = $org$boislocal$platform.f2 || ($org$boislocal$platform.f2 = {});
    var $org$boislocal$platform$f2$realization = $org$boislocal$platform$f2.realization || ($org$boislocal$platform$f2.realization = {});
    var $org$boislocal$platform$f2$realization$query = $org$boislocal$platform$f2$realization.query || ($org$boislocal$platform$f2$realization.query = {});
    var $org$boislocal$platform$f2$realization$query$domain = $org$boislocal$platform$f2$realization$query.domain || ($org$boislocal$platform$f2$realization$query.domain = {});
    var $org$boislocal$platform$f2$realization$query$domain$policy = $org$boislocal$platform$f2$realization$query$domain.policy || ($org$boislocal$platform$f2$realization$query$domain.policy = {});
    defineProp($org$boislocal$platform$f2$realization$query$domain$policy, 'OuvragePolicies', OuvragePolicies_getInstance);
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$f2 = $org$boislocal$platform.f2 || ($org$boislocal$platform.f2 = {});
    var $org$boislocal$platform$f2$ouvrage = $org$boislocal$platform$f2.ouvrage || ($org$boislocal$platform$f2.ouvrage = {});
    var $org$boislocal$platform$f2$ouvrage$query = $org$boislocal$platform$f2$ouvrage.query || ($org$boislocal$platform$f2$ouvrage.query = {});
    var $org$boislocal$platform$f2$ouvrage$query$domain = $org$boislocal$platform$f2$ouvrage$query.domain || ($org$boislocal$platform$f2$ouvrage$query.domain = {});
    var $org$boislocal$platform$f2$ouvrage$query$domain$query = $org$boislocal$platform$f2$ouvrage$query$domain.query || ($org$boislocal$platform$f2$ouvrage$query$domain.query = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$f2 = $org$boislocal$platform.f2 || ($org$boislocal$platform.f2 = {});
    var $org$boislocal$platform$f2$ouvrage = $org$boislocal$platform$f2.ouvrage || ($org$boislocal$platform$f2.ouvrage = {});
    var $org$boislocal$platform$f2$ouvrage$query = $org$boislocal$platform$f2$ouvrage.query || ($org$boislocal$platform$f2$ouvrage.query = {});
    var $org$boislocal$platform$f2$ouvrage$query$domain = $org$boislocal$platform$f2$ouvrage$query.domain || ($org$boislocal$platform$f2$ouvrage$query.domain = {});
    var $org$boislocal$platform$f2$ouvrage$query$domain$query = $org$boislocal$platform$f2$ouvrage$query$domain.query || ($org$boislocal$platform$f2$ouvrage$query$domain.query = {});
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  //endregion
  return _;
}));

//# sourceMappingURL=boislocal-platform-platform-f2-ouvrage-query-ouvrage-query-domain.js.map
